import React, { useEffect, useRef, useState } from "react";

export default function CompareModalTrigger({
  onOpen,
  onCompareCombineHistory,
}) {
  const [isOpen, setIsOpen] = useState(false);
  const ref = useRef(null);

  useEffect(() => {
    const handler = (e) => {
      if (ref.current && !ref.current.contains(e.target)) setIsOpen(false);
    };
    document.addEventListener("mousedown", handler);
    return () => document.removeEventListener("mousedown", handler);
  }, []);

  return (
    <div className="relative" ref={ref}>
      <button
        type="button"
        onClick={() => setIsOpen((prev) => !prev)}
        className="text-blue-600 hover:text-blue-800 text-sm flex items-center gap-2"
      >
        <img className="h-5" alt="Compare" src="/compare.svg" />
        Compare
      </button>

      {isOpen && (
        <div className="absolute right-0 mt-2 z-50 w-56 bg-white border border-gray-200 rounded-lg shadow-lg">
          <button
            type="button"
            className="w-full text-left px-4 py-3 text-sm text-gray-700 hover:bg-gray-50 rounded-t-lg"
            onClick={() => {
              setIsOpen(false);
              onOpen();
            }}
          >
            Compare to another player
          </button>
          <hr className="border-gray-100" />
          <button
            type="button"
            className="w-full text-left px-4 py-3 text-sm text-gray-700 hover:bg-gray-50 rounded-b-lg"
            onClick={() => {
              setIsOpen(false);
              onCompareCombineHistory();
            }}
          >
            Compare athlete combine history
          </button>
        </div>
      )}
    </div>
  );
}
